module.exports = __webpack_public_path__ + "img/b704bb4.jpg";